import { render } from "./SecurityPopup.vue?vue&type=template&id=62ba3196&scoped=true&ts=true"
import script from "./SecurityPopup.vue?vue&type=script&lang=ts"
export * from "./SecurityPopup.vue?vue&type=script&lang=ts"

import "./SecurityPopup.vue?vue&type=style&index=0&id=62ba3196&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ba3196"]])

export default __exports__